import { SVGProps } from "react";

const EditIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="icono-editar"
      {...props}
    >
      <path
        d="M7.51003 0.510148C8.05676 -0.0365858 8.94319 -0.0365858 9.48992 0.510148C10.0367 1.05688 10.0367 1.94331 9.48992 2.49005L8.9349 3.04507L6.955 1.06517L7.51003 0.510148Z"
        fill="#6B7280"
      />
      <path
        d="M5.96505 2.05512L0.0999756 7.9202V9.9001H2.07987L7.94495 4.03502L5.96505 2.05512Z"
        fill="#6B7280"
      />
    </svg>
  );
};

export default EditIcon;
